import React, { useEffect, useState } from "react";
import successImage from "../../../../../assets/Graphics/Success page graphic.svg";
import WhitedashBoard from "../../../../../assets/GeneralIcons/dashboard.svg";
import "./index.css";
import { Tooltip, tooltipClasses } from "@mui/material";
import Queued from "../../../../../assets/AwaitingIcons/queued.svg";
import { Link } from "react-router-dom";
import pending_yellow from "../../../../../assets/PendingIcons/pending_blue.svg";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import ArrowRightBlue from "../../../../../assets/ArrowsIcons/arrow_right_blue.svg";
import ArrowDownCircle from "../../../../../assets/ArrowsIcons/arrow_down_blue_white.svg";
import { formatAccountNumber } from "../../../../../components/_utils/FormatAccountNumber";

const InternalMultiApprovalTxnSuccess = () => {
  const [successPageData, setsuccessPageData] = useState([]);
  const [successPageID, setsuccessPageID] = useState([]);
  const [pendingTransactions, setPendingTransactions] = useState([]);
  const [isMobileResponsive, setIsMobileResponsive] = useState(
    window.innerWidth <= 800
  );
  const [approvedTransactions, setApprovedTransactions] = useState([]);
  const [activeTab, setActiveTab] = useState("approved");
  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData")
    );

    if (storedSelectedApproval) {
      const transactions =
        storedSelectedApproval?.selectedSendTransactions || [];

      const pending = transactions.filter(
        (transaction) => transaction.lifecycle_status === "pending"
      );
      const approved = transactions.filter(
        (transaction) => transaction.lifecycle_status === "approved"
      );
      setsuccessPageData(storedSelectedApproval?.selectedSendTransactions);
      setPendingTransactions(pending);
      setApprovedTransactions(approved);
      setsuccessPageID(storedSelectedApproval.selectedTransactions);
    } else {
      setsuccessPageData([]);
      setsuccessPageID([]);
    }
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setIsMobileResponsive(window.innerWidth <= 800);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);
  const TransactionList = ({ transactions, type }) => (
    <>
      {isMobileResponsive ? (
        <>
          <div
            className=" bg-[#F9F9F9]"
            style={{
              overflowY: transactions.length >= 2 ? "scroll" : "hidden",
              paddingBottom: "10px",
              height: "calc(100vh - 352px)",
            }}
          >
            <div
              className="w-full"
              style={{
                overflowY: transactions.length >= 2 ? "scroll" : "hidden",
                paddingTop: "15px",
                paddingBottom: "20px",
              }}
            >
              {transactions?.map((account, i) => {
                return (
                  <>
                    <div className="w-full h-8 bg-[#E9E9E9]flex flex-col gap-[10px] flex items-center">
                      <div className="flex justify-between px-[15px] w-full">
                        <p className="font-semibold text-base text-[#4DDD37]">
                          ₹ {<FormatAmount price={account?.amount} />}
                        </p>
                        <span className="font-sans text-xs text-[#707070] opacity-100 pt-[5px]">
                          Amount
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-col gap-[10px]">
                      <div className="flex flex-col justify-center items-start gap-[10px] pt-3 px-[15px]">
                        <div>
                          <Tooltip
                            componentsProps={{
                              popper: {
                                sx: {
                                  [`& .${tooltipClasses.tooltip}`]: {
                                    backgroundColor: (theme) =>
                                      theme.palette.common.black,
                                  },
                                },
                              },
                            }}
                            title={account?.owner_account_bank_acc_no}
                          >
                            <p className="w-full h-[22px] text-left font-sans font-medium text-[14px] text-[#1D1D1D]">
                              {formatAccountNumber(
                                account?.owner_account_bank_acc_no
                              )}
                            </p>
                          </Tooltip>
                          <span className="flex text-left font-sans text-[11px] text-[#707070] opacity-100">
                            Source account number
                          </span>
                        </div>
                      </div>
                      <div className="relative border-b border-[#DADADA]">
                        <img
                          src={ArrowDownCircle}
                          alt="Arrow Down"
                          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[30px] h-[30px]"
                        />
                      </div>

                      <div className="flex flex-col justify-center items-start gap-[10px] pt-3 px-[15px]">
                        <div>
                          <Tooltip
                            componentsProps={{
                              popper: {
                                sx: {
                                  [`& .${tooltipClasses.tooltip}`]: {
                                    backgroundColor: (theme) =>
                                      theme.palette.common.black,
                                  },
                                },
                              },
                            }}
                            title={account?.beneficiary_account_name}
                          >
                            <p className="w-full h-[22px] text-left font-sans font-medium text-[14px] text-[#1D1D1D]">
                              {formatAccountNumber(
                                account?.internal_account_bank_acc_no
                              )}
                            </p>
                          </Tooltip>
                          <span className="flex text-left font-sans text-[11px] text-[#707070] opacity-100">
                            Destination account number
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* {i < transactions.length - 1 && (
                      <div
                        style={{
                          marginTop: "10px",
                          border: "0.5px solid #4A664D",
                          height: "0px",
                          opacity: "100",
                        }}
                      ></div>
                    )} */}
                  </>
                );
              })}
            </div>
          </div>
          <div className="relative h-[105px] rounded-tl-[20px] bg-[#55985C] top-[-13px] rounded-tr-[20px]">
            <Link to={"/transaction/internal_transaction/dashboard"}>
              <div className="flex flex-col gap-1 justify-center items-center h-full">
                <img
                  className="w-[33px] h-[33px]"
                  src={WhitedashBoard}
                  alt=""
                />
                <p className="w-[63px] h-[32px] text-center text-xs font-semibold text-[#F9F9F9]">
                  Go to dashboard
                </p>
              </div>
            </Link>
          </div>
        </>
      ) : (
        <div
          className="h-[345px] w-full flex overflow-hidden mb-5"
          style={{
            overflowY: transactions.length > 3 ? "auto" : "hidden",
          }}
        >
          <div className="w-full">
            {transactions?.map((account, i) => (
              <div key={i}>
                <div className="w-full h-8 bg-[#E9E9E9] mt-[15px] flex items-center">
                  <div className="flex justify-between px-5 w-full">
                    <p className="font-semibold text-base text-[#4DDD37]">
                      ₹ {<FormatAmount price={account?.amount} />}
                    </p>
                    <span className="font-sans text-xs text-[#707070] opacity-100 items-center pt-[5px]">
                      Amount
                    </span>
                  </div>
                </div>
                <div className="flex my-2.5 justify-between px-5">
                  <div className="flex justify-start items-center gap-[10px] w-full">
                    <div>
                      <Tooltip
                        componentsProps={{
                          popper: {
                            sx: {
                              [`& .${tooltipClasses.tooltip}`]: {
                                backgroundColor: (theme) =>
                                  theme.palette.common.black,
                              },
                            },
                          },
                        }}
                        title={account?.owner_account_bank_acc_no}
                      >
                        <p className="w-[167px] h-[22px] text-left font-sans text-sm leading-[22px] tracking-normal text-[#1D1D1D]">
                          {formatAccountNumber(
                            account?.owner_account_bank_acc_no
                          )}
                        </p>
                      </Tooltip>
                      <span className="flex items-start font-sans text-[12px] leading-[17px] tracking-normal text-[#707070] opacity-100">
                        Source account number
                      </span>
                    </div>
                  </div>

                  <img
                    src={ArrowRightBlue}
                    alt="ArrowRightBlue"
                    className="h-[18px] w-[18px] self-center"
                  />

                  <div className="flex justify-end items-start gap-[10px] w-full">
                    <div className="text-right">
                      <Tooltip
                        componentsProps={{
                          popper: {
                            sx: {
                              [`& .${tooltipClasses.tooltip}`]: {
                                backgroundColor: (theme) =>
                                  theme.palette.common.black,
                              },
                            },
                          },
                        }}
                        title={account?.internal_account_bank_acc_no}
                      >
                        <p className="w-[167px] h-[22px] text-right font-sans text-sm leading-[22px] tracking-normal text-[#1D1D1D]">
                          {formatAccountNumber(
                            account?.internal_account_bank_acc_no
                          )}
                        </p>
                      </Tooltip>
                      <span className="flex items-start ml-3 font-sans text-xs leading-[17px] tracking-normal text-[#707070] opacity-100">
                        Destination account number
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );

  return (
    <>
      {isMobileResponsive ? (
        <div className=" bg-[#4D8352]" style={{ height: "100vh" }}>
          <div className="flex flex-col justify-center items-center">
            <img className="h-[170px]" src={successImage} alt="successImage" />
            <p className="text-center text-[14px] font-semibold  text-[#F9F9F9] opacity-100">
              Transactions have been approved.
            </p>
          </div>

          <div
            className="pt-5"
            style={{
              height: "calc(100vh - 232px)",
            }}
          >
            {pendingTransactions.length > 0 &&
              approvedTransactions.length === 0 && (
                <>
                  <div
                    className="w-full flex flex-col items-center h-[46px] gap-0 rounded-b-none"
                    style={{
                      background: "#69B76F",
                    }}
                  >
                    <p className="text-base font-semibold text-[#F9F9F9] pt-[10px]">
                      Pending - {pendingTransactions.length}
                    </p>
                  </div>
                  <div
                    className="bg-[#F9F9F9]"
                    style={{
                      overflowY:
                        pendingTransactions.length >= 2 ? "scroll" : "hidden",
                      paddingBottom: "20px",
                      height: "calc(100vh - 352px)",
                    }}
                  >
                    <div
                      className=""
                      style={{
                        overflowY:
                          pendingTransactions.length >= 2 ? "scroll" : "hidden",
                        paddingBottom: "10px",
                        paddingTop: "15px",
                      }}
                    >
                      {pendingTransactions?.map((account, i) => {
                        return (
                          <>
                            <div className="w-full h-8 bg-[#E9E9E9] flex items-center">
                              <div className="flex justify-between px-5 w-full">
                                <p className="font-semibold text-base text-[#4DDD37]">
                                  ₹ {<FormatAmount price={account?.amount} />}
                                </p>
                                <p className="font-sans text-xs text-[#707070] opacity-100 items-center pt-1">
                                  Amount
                                </p>
                              </div>
                            </div>
                            <div className="flex flex-col gap-[10px]">
                              <div className="flex flex-col justify-center items-start gap-[10px] pt-3 px-[15px]">
                                <div>
                                  <Tooltip
                                    componentsProps={{
                                      popper: {
                                        sx: {
                                          [`& .${tooltipClasses.tooltip}`]: {
                                            backgroundColor: (theme) =>
                                              theme.palette.common.black,
                                          },
                                        },
                                      },
                                    }}
                                    title={account?.owner_account_bank_acc_no}
                                  >
                                    <p className="w-[167px] h-[22px] text-left font-sans font-medium text-[14px] text-[#1D1D1D]">
                                      {formatAccountNumber(
                                        account?.owner_account_bank_acc_no
                                      )}
                                    </p>
                                  </Tooltip>
                                  <span className="flex text-left font-sans text-[11px] text-[#707070] opacity-100">
                                    Source account number
                                  </span>
                                </div>
                              </div>
                              <div className="relative border-b border-[#DADADA]">
                                <img
                                  src={ArrowDownCircle}
                                  alt="Arrow Down"
                                  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[30px] h-[30px]"
                                />
                              </div>

                              <div className="flex flex-col justify-center items-start gap-[10px] pt-3 px-[15px]">
                                <div>
                                  <Tooltip
                                    componentsProps={{
                                      popper: {
                                        sx: {
                                          [`& .${tooltipClasses.tooltip}`]: {
                                            backgroundColor: (theme) =>
                                              theme.palette.common.black,
                                          },
                                        },
                                      },
                                    }}
                                    title={
                                      account?.internal_account_bank_acc_no
                                    }
                                  >
                                    <p className="w-[167px] h-[22px] text-left font-sans font-medium text-[14px] text-[#1D1D1D]">
                                      {formatAccountNumber(
                                        account?.internal_account_bank_acc_no
                                      )}
                                    </p>
                                  </Tooltip>
                                  <span className="flex text-left font-sans text-[11px] text-[#707070] opacity-100">
                                    Destination account number
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* {i < pendingTransactions.length - 1 && (
                              <div
                                style={{
                                  marginTop: "10px",
                                  border: "0.5px solid #4A664D",
                                  height: "0px",
                                  opacity: "100",
                                }}
                              ></div>
                            )} */}
                          </>
                        );
                      })}
                    </div>
                  </div>
                  <div className="relative h-[105px] rounded-tl-[20px] bg-[#55985C] top-[-13px] rounded-tr-[20px]">
                    <Link to={"/transaction/internal_transaction/dashboard"}>
                      <div className="flex flex-col gap-1 justify-center items-center h-full">
                        <img
                          className="w-[33px] h-[33px]"
                          src={WhitedashBoard}
                          alt=""
                        />
                        <p className="w-[63px] h-[32px] text-center text-xs font-semibold text-[#F9F9F9]">
                          Go to dashboard
                        </p>
                      </div>
                    </Link>
                  </div>
                </>
              )}

            {approvedTransactions.length > 0 &&
              pendingTransactions.length === 0 && (
                <>
                  <div
                    className="w-full flex flex-col items-center h-[46px] gap-0 rounded-b-none"
                    style={{
                      background: "#69B76F",
                    }}
                  >
                    <p className="text-base font-semibold text-[#F9F9F9] pt-[10px]">
                      Distribution created - {approvedTransactions.length}
                    </p>
                  </div>
                  <div
                    className=" bg-[#F9F9F9]"
                    style={{
                      overflowY:
                        successPageData.length >= 2 ? "scroll" : "hidden",
                      paddingBottom: "10px",
                      paddingTop: "15px",
                      height: "calc(100vh - 352px)",
                    }}
                  >
                    <div
                      className=""
                      style={{
                        overflowY:
                          successPageData.length >= 2 ? "scroll" : "hidden",
                        paddingBottom: "10px",
                      }}
                    >
                      {successPageData?.map((account, i) => {
                        return (
                          <>
                            <div className="w-full h-8 bg-[#E9E9E9] mt-2 flex items-center">
                              <div className="flex justify-between px-5 w-full">
                                <p className="font-semibold text-base text-[#4DDD37]">
                                  ₹ {<FormatAmount price={account?.amount} />}
                                </p>
                                <p className="font-sans text-xs text-[#707070] opacity-100 items-center pt-1">
                                  Amount
                                </p>
                              </div>
                            </div>
                            <div className="flex flex-col gap-[10px]">
                              <div className="flex flex-col justify-center items-start gap-[10px] pt-3 px-[15px]">
                                <div>
                                  <Tooltip
                                    componentsProps={{
                                      popper: {
                                        sx: {
                                          [`& .${tooltipClasses.tooltip}`]: {
                                            backgroundColor: (theme) =>
                                              theme.palette.common.black,
                                          },
                                        },
                                      },
                                    }}
                                    title={account?.owner_account_bank_acc_no}
                                  >
                                    <p className="w-[167px] h-[22px] text-left font-sans font-medium text-[14px] text-[#1D1D1D]">
                                      {formatAccountNumber(
                                        account?.owner_account_bank_acc_no
                                      )}
                                    </p>
                                  </Tooltip>
                                  <span className="flex text-left font-sans text-[11px] text-[#707070] opacity-100">
                                    Source account number
                                  </span>
                                </div>
                              </div>
                              <div className="relative border-b border-[#DADADA]">
                                <img
                                  src={ArrowDownCircle}
                                  alt="Arrow Down"
                                  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[30px] h-[30px]"
                                />
                              </div>

                              <div className="flex flex-col justify-center items-start gap-[10px] pt-3 px-[15px]">
                                <div>
                                  <Tooltip
                                    componentsProps={{
                                      popper: {
                                        sx: {
                                          [`& .${tooltipClasses.tooltip}`]: {
                                            backgroundColor: (theme) =>
                                              theme.palette.common.black,
                                          },
                                        },
                                      },
                                    }}
                                    title={
                                      account?.internal_account_bank_acc_no
                                    }
                                  >
                                    <p className="w-[167px] h-[22px] text-left font-sans font-medium text-[14px] text-[#1D1D1D]">
                                      {formatAccountNumber(
                                        account?.internal_account_bank_acc_no
                                      )}
                                    </p>
                                  </Tooltip>
                                  <span className="flex text-left font-sans text-[11px] text-[#707070] opacity-100">
                                    Destination account number
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* {i < pendingTransactions.length - 1 && (
                              <div
                                style={{
                                  marginTop: "10px",
                                  border: "0.5px solid #4A664D",
                                  height: "0px",
                                  opacity: "100",
                                }}
                              ></div>
                            )} */}
                          </>
                        );
                      })}
                    </div>
                  </div>
                  <div className="relative h-[105px] rounded-tl-[20px] bg-[#55985C] top-[-13px] rounded-tr-[20px]">
                    <Link to={"/transaction/internal_transaction/dashboard"}>
                      <div className="flex flex-col gap-1 justify-center items-center h-full">
                        <img
                          className="w-[33px] h-[33px]"
                          src={WhitedashBoard}
                          alt=""
                        />
                        <p className="w-[63px] h-[32px] text-center text-xs font-semibold text-[#F9F9F9]">
                          Go to dashboard
                        </p>
                      </div>
                    </Link>
                  </div>
                </>
              )}

            {approvedTransactions.length > 0 &&
              pendingTransactions.length > 0 && (
                <>
                  <div
                    className="flex justify-between h-[46px] gap-0 rounded-b-none "
                    style={{
                      background: "#69B76F",
                    }}
                  >
                    <button
                      onClick={() => setActiveTab("approved")}
                      className={
                        activeTab === "approved"
                          ? "activeoneMobile"
                          : "tabbutton1Mobile"
                      }
                    >
                      <h5 className="h-[17px] whitespace-nowrap text-left font-semibold text-[13px] leading-[17px] text-[#F9F9F9] opacity-100">
                        Distribution created - {approvedTransactions.length}
                      </h5>
                    </button>
                    <button
                      onClick={() => setActiveTab("pending")}
                      className={
                        activeTab === "pending"
                          ? "activetwoMobile"
                          : "tabbutton2Mobile"
                      }
                    >
                      <h5 className="h-[17px] whitespace-nowrap font-semibold text-[13px] leading-[17px] text-[#F9F9F9] opacity-100">
                        Pending - {pendingTransactions.length}
                      </h5>
                    </button>
                  </div>
                  {activeTab === "approved" ? (
                    <TransactionList
                      transactions={approvedTransactions}
                      type={"Approved"}
                    />
                  ) : (
                    <TransactionList
                      transactions={pendingTransactions}
                      type={"Pending"}
                    />
                  )}
                </>
              )}
          </div>
        </div>
      ) : (
        <div className="min-h-screen bg-[#457549]">
          <div className="flex justify-center">
            <div className="flex flex-row max-w-screen-lg justify-center">
              <div className="flex-1 mt-[66px] pt-[112px]">
                <div className="flex min-w-screen mx-5 justify-center items-center bg-[#457549]">
                  <div className="p-2 flex flex-col items-center justify-center text-center text-white text-2xl">
                    <img
                      src={successImage}
                      width={"100%"}
                      height={"100%"}
                      alt="success"
                    />
                    <div className="pt-7">
                      <p className="text-xl font-semibold text-[#F9F9F9]">
                        Transactions have been approved.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-1 mt-[66px] py-[35px]">
                <div className="flex flex-col h-[554px] w-[472px] mx-5 bg-[#FFFFFF] rounded-[20px] items-center justify-between">
                  {pendingTransactions.length > 0 &&
                    approvedTransactions.length === 0 && (
                      <>
                        <div className="flex flex-col gap-1 justify-center items-center h-[85px] w-[472px] bg-[#55985C] rounded-tl-[18px] rounded-tr-[18px]">
                          <p className="whitespace-nowrap  font-semibold text-[16px]  text-[#F9F9F9] opacity-100">
                            Pending - {pendingTransactions.length}
                          </p>

                          <span className="w-[472px]  text-center font-normal text-[12px] h-[16px] text-[#DADADA] opacity-100 ">
                            It is approved and requires another user's approval
                            before distribution.
                          </span>
                        </div>

                        <div className="h-[345px] w-full flex my-5 overflow-y-auto">
                          <div className="w-full">
                            {pendingTransactions?.map((account, i) => (
                              <>
                                <div className="w-full h-8 bg-[#E9E9E9] flex items-center">
                                  <div className="flex justify-between px-5 w-full">
                                    <p className="font-semibold text-base text-[#4DDD37]">
                                      ₹ <FormatAmount price={account?.amount} />
                                    </p>
                                    <p className="font-sans text-xs text-[#707070] opacity-100 items-center pt-[5px]">
                                      Amount
                                    </p>
                                  </div>
                                </div>
                                <div className="flex my-2.5 justify-between px-5">
                                  <div className="flex justify-start items-center gap-[10px] w-full">
                                    <div>
                                      <Tooltip
                                        componentsProps={{
                                          popper: {
                                            sx: {
                                              [`& .${tooltipClasses.tooltip}`]:
                                                {
                                                  backgroundColor: (theme) =>
                                                    theme.palette.common.black,
                                                },
                                            },
                                          },
                                        }}
                                        title={
                                          account?.owner_account_bank_acc_no
                                        }
                                      >
                                        <p className="w-[167px] h-[22px] text-left font-sans text-sm leading-[22px] tracking-normal text-[#1D1D1D]">
                                          {formatAccountNumber(
                                            account?.owner_account_bank_acc_no
                                          )}
                                        </p>
                                      </Tooltip>
                                      <span className="flex items-start font-sans text-[12px] leading-[17px] tracking-normal text-[#707070] opacity-100">
                                        Source account number
                                      </span>
                                    </div>
                                  </div>
                                  <img
                                    src={ArrowRightBlue}
                                    alt="ArrowRightBlue"
                                    className="h-[18px] w-[18px] self-center"
                                  />
                                  <div className="flex justify-end items-start gap-[10px] w-full">
                                    <div className="text-right">
                                      <Tooltip
                                        componentsProps={{
                                          popper: {
                                            sx: {
                                              [`& .${tooltipClasses.tooltip}`]:
                                                {
                                                  backgroundColor: (theme) =>
                                                    theme.palette.common.black,
                                                },
                                            },
                                          },
                                        }}
                                        title={
                                          account?.internal_account_bank_acc_no
                                        }
                                      >
                                        <p className="w-[167px] h-[22px] text-right font-sans text-sm leading-[22px] tracking-normal text-[#1D1D1D]">
                                          {formatAccountNumber(
                                            account?.internal_account_bank_acc_no
                                          )}
                                        </p>
                                      </Tooltip>
                                      <span className="flex items-start ml-3 font-sans text-xs leading-[17px] tracking-normal text-[#707070] opacity-100">
                                        Destination account number
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ))}
                          </div>
                        </div>
                      </>
                    )}

                  {approvedTransactions.length > 0 &&
                    pendingTransactions.length === 0 && (
                      <>
                        <div className="h-[77px] w-[472px] bg-[#55985C] rounded-tl-[18px] rounded-tr-[18px]">
                          <div className="flex justify-center mt-[14px] gap-[10px]">
                            <p className="w-[181px] whitespace-nowrap text-left font-semibold text-[16px] leading-[22px] tracking-[0px] text-[#F9F9F9] opacity-100">
                              {" "}
                              Distribution created -{" "}
                              {approvedTransactions.length}
                            </p>
                          </div>
                          <div className="flex justify-center mt-[8px]">
                            <p className="w-[284px] text-center font-normal whitespace-nowrap mr-8 text-[12px] leading-[17px] tracking-[0px] text-[#DADADA] opacity-100">
                              The transaction has been approved and is set for
                              distribution.
                            </p>
                          </div>
                        </div>

                        <div className="h-[345px] w-full flex overflow-y-auto mb-5 pt-4">
                          <div
                            className="w-full"
                            style={{
                              height: "fit-content",
                              paddingBottom: "5px",
                            }}
                          >
                            {successPageData?.map((account, i) => {
                              return (
                                <>
                                  <div className="w-full h-8 bg-[#E9E9E9] mt-2 flex items-center">
                                    <div className="flex justify-between px-5 w-full">
                                      <p className="font-semibold text-base text-[#4DDD37]">
                                        ₹{" "}
                                        {
                                          <FormatAmount
                                            price={account?.amount}
                                          />
                                        }
                                      </p>
                                      <p className="font-sans text-xs text-[#707070] opacity-100 items-center pt-[5px]">
                                        Amount
                                      </p>
                                    </div>
                                  </div>
                                  <div className="flex my-2.5 justify-between px-5">
                                    <div className="flex justify-start items-center gap-[10px] w-full">
                                      <div>
                                        <Tooltip
                                          componentsProps={{
                                            popper: {
                                              sx: {
                                                [`& .${tooltipClasses.tooltip}`]:
                                                  {
                                                    backgroundColor: (theme) =>
                                                      theme.palette.common
                                                        .black,
                                                  },
                                              },
                                            },
                                          }}
                                          title={
                                            account?.owner_account_bank_acc_no
                                          }
                                        >
                                          <p className="w-[167px] h-[22px] text-left font-sans text-sm leading-[22px] tracking-normal text-[#1D1D1D]">
                                            {formatAccountNumber(
                                              account?.owner_account_bank_acc_no
                                            )}
                                          </p>
                                        </Tooltip>
                                        <span className="flex items-start font-sans text-[12px] leading-[17px] tracking-normal text-[#707070] opacity-100">
                                          Source account number
                                        </span>
                                      </div>
                                    </div>

                                    <img
                                      src={ArrowRightBlue}
                                      alt="ArrowRightBlue"
                                      className="h-[18px] w-[18px] self-center"
                                    />

                                    <div className="flex justify-end items-start gap-[10px] w-full">
                                      <div className="text-right">
                                        <Tooltip
                                          componentsProps={{
                                            popper: {
                                              sx: {
                                                [`& .${tooltipClasses.tooltip}`]:
                                                  {
                                                    backgroundColor: (theme) =>
                                                      theme.palette.common
                                                        .black,
                                                  },
                                              },
                                            },
                                          }}
                                          title={
                                            account?.internal_account_bank_acc_no
                                          }
                                        >
                                          <p className="w-[167px] h-[22px] text-right font-sans text-sm leading-[22px] tracking-normal text-[#1D1D1D]">
                                            {formatAccountNumber(
                                              account?.internal_account_bank_acc_no
                                            )}
                                          </p>
                                        </Tooltip>
                                        <span className="flex items-start ml-3 font-sans text-[12px] leading-[17px] tracking-normal text-[#707070] opacity-100">
                                          Destination account number
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  {/* {i < successPageData.length - 1 && (
                                    <div
                                      style={{
                                        marginTop: "10px",
                                        border: "0.5px solid #4A664D",
                                        height: "0px",
                                        width: "411px",
                                        opacity: "100",
                                      }}
                                    ></div>
                                  )} */}
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </>
                    )}

                  {approvedTransactions.length > 0 &&
                    pendingTransactions.length > 0 && (
                      <>
                        <div className="h-[93px] w-[472px] bg-[#4C8452] rounded-tl-[18px] rounded-tr-[18px]">
                          <div className=" flex justify-between">
                            <button
                              onClick={() => setActiveTab("approved")}
                              className={
                                activeTab === "approved"
                                  ? "activeone"
                                  : "tabbutton1"
                              }
                            >
                              <h5 className="w-[136px] h-[17px] whitespace-nowrap text-left font-semibold text-[13px] leading-[17px] text-[#F9F9F9] opacity-100">
                                Distribution created -{" "}
                                {approvedTransactions.length}
                              </h5>
                              <p className="w-[204px] h-[34px] text-center font-normal text-[12px] leading-[14px] text-[#DADADA] opacity-100">
                                The transaction has been approved and is set for
                                distribution.
                              </p>
                            </button>
                            <button
                              onClick={() => setActiveTab("pending")}
                              className={
                                activeTab === "pending"
                                  ? "activetwo"
                                  : "tabbutton2"
                              }
                            >
                              <h5 className="h-[17px] whitespace-nowrap  font-semibold text-[13px] leading-[17px] text-[#F9F9F9] opacity-100">
                                Pending - {pendingTransactions.length}
                              </h5>
                              <p className="w-[204px] h-[34px] text-center text-[12px] leading-[14px] text-[#DADADA] opacity-100 font-normal tracking-normal">
                                It is approved and requires another user's
                                approval before distribution.
                              </p>
                            </button>
                          </div>
                        </div>

                        {activeTab === "approved" ? (
                          <TransactionList
                            transactions={approvedTransactions}
                            type={"Approved"}
                          />
                        ) : (
                          <TransactionList
                            transactions={pendingTransactions}
                            type={"Pending"}
                          />
                        )}
                      </>
                    )}

                  <div className="flex justify-center items-center h-[136px] w-[472px] bg-[#55985C] rounded-[20px]">
                    <Link to={"/transaction/internal_transaction/dashboard"}>
                      <div className="w-[62px] flex justify-center items-center flex-col gap-[4px] h-[76px]">
                        <img
                          className="w-[40px] h-[40px] "
                          src={WhitedashBoard}
                          alt=""
                        />
                        <p className="w-[62px] h-[32px] text-center font-semibold text-xs leading-[15px] tracking-[0px] text-[#F9F9F9] opacity-100">
                          Go to dashboard
                        </p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InternalMultiApprovalTxnSuccess;
